import type { User } from '@scrambl/shared';
import { useAuth } from '@/store/auth.store';
/**
 * Synchronizes auth state between React Context and Zustand store
 */
export const syncAuthState = (user: User | null, isAuthenticated: boolean, isLoading: boolean) => {
  // Update the auth store with the current state
  useAuth.setState(state => {
    // Only update if there's a change to prevent infinite loops
    if (state.user !== user || 
        state.isAuthenticated !== isAuthenticated || 
        state.isLoading !== isLoading ||
        state.user?.setupComplete !== user?.setupComplete) {
      
      // Use the user object directly without preserving setupComplete
      const updatedUser = user ? {
        ...user,
        setupComplete: user.setupComplete // Use the value directly from the user object
      } : null;
return {
        ...state,
        user: updatedUser,
        isAuthenticated,
        isLoading,
        isAuthReady: !isLoading
      };
    }
    return state;
  });
};

/**
 * Checks if a user needs to complete profile setup
 * A user needs to complete their profile if setupComplete is false
 */
export function needsProfileSetup(user: User | null): boolean {
  if (!user) return true;

  // ONLY check the setupComplete flag from the backend
  // This is the source of truth for setup completion status
  return user.setupComplete !== true;
}

/**
 * Redirects user to the appropriate page based on auth status
 * If authenticated, redirects to dashboard or user-setup based on profile completion
 * If not authenticated, redirects to login
 */
export const redirectBasedOnAuthStatus = (navigate: (path: string) => void, user: User | null, isAuthenticated: boolean) => {
  if (!isAuthenticated) {
    navigate('/login');
    return;
  }
  
  if (needsProfileSetup(user)) {
    navigate('/user-setup');
    return;
  }
  
  // Navigate to organizations page after auth instead of directly to dashboard
  // This ensures proper flow through organization selection
  navigate('/organizations');
}; 